<div class="repetition-container" *ngFor="let rep of question.repetitions">
  <div class="repetition" *ngIf="rep.showInForm">
    <bepatient-question-v3
      *ngFor="let ques of rep"
      [id]="'question-' + ques.key"
      [color]="color"
      [formGroup]="formGroup"
      [question]="ques"
      [readonly]="readonly"
      [class.readonly]="readonly"
    >
    </bepatient-question-v3>
  </div>
</div>
